// extracted by mini-css-extract-plugin
module.exports = {"con":"portal_con__20r75"};